/**
 * 中文繁体
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "中文",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "英文",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "繁體中文",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "日文",
			langimg: "../assets/zg.png"
		},

		{
			type: "Vietnamese",
			name: "越南語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "馬來語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "印度語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "泰語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "俄語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "印尼語",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "traditional",
		langimg: "../assets/zg.png"
	},
	tabbar: { //底部
		index: "首頁",
		activity: "活動",
		to_promote: "推廣",
		help: "幫助",
		my: "我的"
	},
	// 提示
	prompt: {
		verification: "驗證碼錯誤",
		account: "帳號8-20比特純數位或字母",
		password: "密碼大於等於6比特數位+字母或字元組合",
		two: "兩次密碼不一致",
		successful: "注册成功",
		loginsuccessful: "登入成功",
		null: "帳號密碼不能為空",
		Binding: "綁定成功",
		address: "請填寫地址",
		Please_choose: "請先選擇一項並輸入下注金額",
		Bet_type: "請先選擇下注類型",
		success: "下注成功",
		complete_password: "請輸入完整的密碼",
		copy_success: "已複製到剪切板",
		copy_fail: "複製失敗",
		Set_success: "設定成功",
		Set_password: "請設定6位數密碼，不能包含“字母、符合、空格”",
		update_success: "修改成功",
		input_number: "請輸入數量",
		addressvalue: "請選擇錢包地址"
	},
	head: { //头部
		luckyhash: "雜湊押注",
		address: "綁定錢包地址",
		history: "投注歷史",
		help: "幫助",
		lotteryRecord: "開獎記錄",
		notice: "公告清單",
		question: "常見問題",
		performance: "獎勵",
		add_address: "添加錢包",
		asset: "資產密碼",
		balance: "餘額明細",
		exchangeRecord: "兌換",
		forrecord: "兌換記錄",
		language: "語言設定",
		update_assets_password: "修改資產密碼",
		update_login_password: "修改登入密碼",

		myteam: "我的團隊",
		recharge: "餘額充值",
		setting: "設定",
		transactiondetails: "投注記錄",
		transfer: "傭金轉移",
		user: "個人中心",
		userInfo: "個人資料",
		withdrawal: "提現",
		commission: "傭金提現",
		withdrawalRecord: "提現記錄",
		top_up: "充值記錄"
	},
	withdrawalRecord: {
		Select_month: "選擇月",
		afterPrice: "餘額",

	},
	withdrawal: {
		withdrawalrecord: "提現記錄",
		commission: "可提現資產",
		number: "要轉移的數量",
		withdrawal_number: "提現數量",
		money_address: "錢包地址",
		addressvalue: "請選擇收款錢包地址",
		poundage: "手續費",
		immediately: "立即提現",
		Warm_prompt: "溫馨提示：請填寫正確的錢包地址，否則無法取款，取款錢包地址一經填寫綁定無法修改，如需修改請聯系客服",
		input_password: '請輸入資產密碼',
		betting: "投注",

	},
	userInfo: {
		Head_portrait: "個人頭像",
		account: "帳號",
		Choose_picture: "選擇頭像",
		cancel: "取消",
		determine: "確定"
	},
	user: {
		wallet_account: "錢包帳戶",
		balance: "餘額明細",
		top_up: "充值",
		withdrawal: "提現",
		my_wallet: "我的錢包",
		add_wallet: "添加錢包",
		look: "查看記錄",
		look_all: "查看更多",
		Pack_up: "收起",
		For_record: "兌換記錄",
		bettingRecord: "交易明細",
		reward: "推廣獎勵",
		goCustomerLink: "線上客服",
		Commission_account: "傭金帳戶",
		transfer: "轉移",
		number: "投注數據",
		transactiondetails: "查看明細",
		day: "今日投注",
		day_winning: "今日中獎",
		my_team: "我的團隊",
		about_we: "關於我們",
		center: "客服中心",
		setting: "設定",
	},
	transfer: {
		money: "傭金餘額",
		account_balance: "帳戶餘額",
		number: "要轉移的數量",
		select: "請選擇",
		Immediately_transfer: "立即轉移",
		password: "請輸入資產密碼",
		betting: "投注",

	},
	transactiondetails: {
		type: "類型",
		input_type: "請選擇類型",
		date: "日期",
		select_date: "請選擇日期",
		select: "査詢",
		bettingmoney: "投注金額",
		winning_amount: "中獎金額",
		time: "時間",
		not: "沒有數據",
		B1: '區塊鏈遊戲-幸運大小',
		B2: '區塊鏈遊戲-幸運組合',
		B3: '區塊鏈遊戲-幸運龍虎',
		B4: '區塊鏈遊戲-幸運莊閑',
		B5: '區塊鏈遊戲-幸运数字',
		A1: '娛樂城-幸運賽車',
		A2: '娛樂城-幸運快艇',
		A3: '娛樂城-幸運賽馬',
		A4: '娛樂城-幸運大小',
		A5: '娛樂城-幸運組合',
		A6: '娛樂城-幸運龍虎',
		A7: '娛樂城-幸運莊閑',
		A8: '娛樂城-幸運數字',
		options: [{
			value: "幸運雜湊-雙面",
			label: "B1",
		},
		{
			value: "幸運雜湊-組合",
			label: "B2",
		},
		{
			value: "幸運雜湊-龍虎合",
			label: "B3",
		},
		{
			value: "幸運雜湊-百家樂",
			label: "B4",
		},
		{
			value: "幸運雜湊-獨膽",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "修改登入密碼",
		assets_pwd: "資產密碼",
		not: "未設定",
		yes: "已設定",
		language: "語言設定",
		exit: "退出",

	},
	recharge: {
		recharge_code: "充值記錄",
		Chain_type: "鏈類型",
		address: "充值地址",
		copy_address: "複製地址",
		remind: "操作提醒",
		content: "内容内容内容内容内容内容内容"
	},
	myteam: {
		select: "査詢",
		time: "日期",
		money: "當日傭金",
		people: "直屬人數",
		team: "團隊",
		jryj: '今日業績',
		jrsy: '今日收益',
		ljsy: '累計收益',
		friendsCategoryList: ['一級', '二級', '三級', '四級', '五級'],
	},
	announcement: {
		title: '最新公告',
		close: '關閉',
	},
	login: {
		order_password: "舊密碼",
		input_ordpwd: "請輸入舊密碼",
		new_pwd: "新密碼",
		number: "請設定6-16比特大小寫字母+數位",
		six_pwd: "請輸入6比特數位密碼",
		confirmPassword: "確認密碼",
		confirm: "確認",
	},
	forrecord: {
		spending: "兌換支出",
	},
	exchangeRecord: {
		exchangeRecord: "兌換",
		record: "記錄",
		For_spending: "兌換支出",
		money: "兌換金額",
		exchange_number: "兌換數量",
		number: "數量",
		market_price: "行情價",
		Miners_fee: "礦工費",
		input_money: "請輸入兌換金額",
		Get_the_amount: "獲得金額",
		Can_be: "可獲得金額",
		address: "錢包地址",
		Immediatelychange: "立即兌換",
		Warm_prompt: "溫馨提示",
		details: "詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情情詳詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情詳情情詳"
	},
	balance: {
		balance_of: "餘額",
		data: "日期",
		dataPickerRange: "請選擇",
		select: "査詢",
		to: 'to'
	},
	asset: {
		password: "請設定6位數密碼，不能包含“字母、符合、空格”",
		confirm: "確認",
	},
	add_address: {
		money_address: "請輸入錢包地址（TRC20）",
		save: "保存"
	},
	spread: {
		cumulative: "您累計邀請",
		people: "人",
		make: "已賺到",
		Continue_to: "繼續努力衝擊大獎",
		url: "分享連結",
		Friends_registered: "好友注册",
		money: "連結錢包",
		Friends_deal: "好友交易",
		copy_url: "複製分享鏈接",
		my_group: "我的團隊",
		look: "查看業績詳情",
		directCount: "直屬人數",
		group: "團隊人數",
		Commission_withdrawal: "傭金提現",
		historyAward: "歷史已領傭金",
		yesterdayAward: "昨日傭金",
		currentAward: "當前可領傭金",
		todayAward: "今日業績",
		my_invite: "我的邀請碼",
		copy_invite: "複製邀請碼",
		top_title: "我的上級",
		update: "綁定上級後無法進行修改",
		nikname: "請輸入需要綁定的上級昵稱",
		binding: "綁定",
		Commission_ratio: "傭金比例",
		level: "級別",
		ratio: "返傭比例（投注額）",
		Directly_under: "直屬下級",
		first: "第",
		levelone: "級",

	},
	performance: {
		datatime: "日期",
		pick: "請選擇",
		select: "査詢",
		total: "今日總業績",
		performance: "業績明細",
		directCount: "直屬玩家人數",
		todayTotalPerformByDirect: "今日直屬玩家業績",
		other: "其他玩家人數",
		todayTotalPerformByOther: "其他玩家業績",
		Commission_withdrawal: "傭金提現",
		historyAward: "歷史已領傭金",
		yesterdayAward: "昨日傭金",
		currentAward: "當前可領傭金",
		todayAward: "今日業績",
		Commission_ratio: "傭金比例",
		level: "級別",
		ratio: "返傭比例（投注額）",
		Directly_under: "直屬下級",
		first: "第",
		levelone: "級",
	},
	lotteryRecord: { //开奖记录
		block: "區塊",
		highly: "區塊高度",
		results_of: "結果",

	},
	help: {
		DAPP: "參與流程",
		a: "複製DAPP遊戲地址進行USDT-TRC20轉帳",
		b: "在錢包區塊鏈瀏覽器（TRX網絡）中打開本網站，即可對DAPP進行立即投注，無需複製",
		Focus_on: "請經常關注重繪我們的主頁，獲得最新交易地址。",
		login: "登入波場官網査詢區塊雜湊值",
		hash: "您可在波場官網査詢您的區塊雜湊值",
		you: "您可在波場官網",
		login_website: "登入波場官網",
		query: "上査詢您的區塊雜湊值",
		look: "點擊查看教程",
		congratulations: "恭喜您",
		winning: "若中獎，系統將在1分鐘內返獎到您",
		address: "若中獎，系統將在1分鐘內返獎到您的轉帳地址中到您的轉帳地址中",
		number: "數位幣交易所中購買USDT和TRX",
		skip: "若您的錢包已有USDT和TRX，可跳過此步驟",
		Digital_currency: "在數位幣交易所中購買USDT和TRX，然後將USDT和TRX轉入您的[去中心化錢包]，您可以使用以下去中心化錢包網站註冊的錢包：",
		platform: "平臺",
		url: "網址",
		tutorial: "教程",
		vpn: "友情提示：若無法打開Telegram，可以使用神VPN",
		vpnurl: "神燈VPN網址",
		whirlwind: "龍捲風加速器網址",
		can_login: "即可登入",
		why: "為什麼選擇xxxx",
		most_fair: "最公平",
		play: "不踢人、不掉線、不受任何干擾",
		Publicly_available: "區塊雜湊值隨機生成，結果統一，無法更改，公開可查",
		security: "最安全",
		no_money: "運營資金可見，不用擔心沒錢返獎",
		Cannot: "所有人轉帳記錄可見，無法虛假宣傳",
		Visi_convenient: "最便捷",
		Without_registration: "無需註冊，無需預充值，無需申請提款",
		questions: "常見問題",
		one: "什麼是【區塊雜湊值】（Block Hash）",
		dna: "區塊雜湊值是一段數據的DNA，每個區塊雜湊值都是唯一的、隨機的且不可破解的。",
		lookintroduce: "點擊查看百度百科雜湊值介紹。",
		what: "什麼區塊鏈",
		Block_chain: "區塊鏈從本質上講，它是一個共亯資料庫，存儲於其中的數據或資訊。 具有不可偽造、全程留痕、可以追溯、公開透明、集體維護等特徵。",
		wallet: "中心化錢包？ 去中心化錢包？ 為什麼中心化錢包無法査詢轉帳？",
		example: "例如：您自己的錢包地址是A，您給地址E轉入10USDT，但您用交易雜湊值去査詢，只能査詢到服務商隨機某個帳本地址B（或C或D等等）與E的轉帳。 同理E也無法得知這10個USDT是否是您轉出的，因為E只能看見是帳本地址B給他轉入10個USDT。 這就是為什麼中心化錢包無法在區塊鞋上査詢真實轉帳資訊。",
		why_winning: "為什麼我會連續中獎或不中獎",
		First: "首先連續多次不中獎的是小概率事件",
		small: "小概率事件定義",
		second: "其次中獎與不中獎是隨機事件，隨機事件的發生的頻率會趨於一個穩定值。 在非反覆運算的情况下，事物出現的概率對每個人來講是相等的，這個情况下，每個人都是公平的。 同時隨機事件會遵大數定律（在試驗不變的條件下，重複試驗多次，隨機事件的頻率近似於它的概率大數定律定義），在轉帳頻次不斷增加的情况下，中獎與不中獎的概率會趨於一—個穩定值。 所以請您繼續轉帳，隨著轉帳頻次新增則中獎總概率會提升。",
		whydelay: "為什麼會延遲到賬",
		Click_to_view: "點擊查看區塊鏈的速度因境：《貴在信任，慢得其所》",
		six: "為什轉幣時有鑰那麼務USDT的類型選項？ 我該選哪一個？",
		global: " 全球有許多知名公鏈",
		click_look: "點擊查看全球知格公鏈簡介",
		how: "轉幣時轉帶地址或選錯幣的類型，怎麼辦？ 是否還能回？",
		For_instance: " 比如說您給我們轉幣時應該選擇USD下TRC20型，但您選擇了其他類型USD下OMNI或者USDERC20，那麼就會出現丟幣的情况，這種情況是無法找回的。",
		How_to_force: "點擊查看如果轉錯幣怎麼辦？",
		Other_problems: "其他問題",
		callwe: "如有任何疑問請聯繫我們",
		immediately: "立即投注",
		company: "公司資訊",
		link: "友情連結",
		register: "注册數位幣去中心化錢包",
		Already_have: "若您有已擁有錢包，可跳過此步驟",
		download: "下載並注册一個數位幣去中心化錢包",
		com_title: "數位幣錢包相關網站教程如下"
	},
	register: { //登录注册
		login_tips: "請重新設定您的登入密碼",
		address: "請輸入錢包地址",
		confirm: "確認密碼",
		confirmupdate: "確認修改",
		toRegister: "去注册",
		agreement: "登入即同意",
		user: "使用者協定",
		policy: "隱私政策",
		welcome: "歡迎來到",
		login: "登入您的帳號",
		forget: "期待您的加入",
		nowLogin: "登入",
		nologin: "暫不登入",
		new: "創建一個新帳戶",
		login: "讓您賺錢更輕鬆",
		account: "帳號8-20比特純數位或字母",
		password: "密碼大於等於6比特數位+字母或字元組合",
		confirm_password: "確認密碼",
		inviteCode: "請輸入邀請碼（選填）",
		verificationCode: "請輸入驗證碼",
		toRegister: "注册",
		noaccount: "沒有帳號",
		toLogin: "去登入"
	},
	address: {
		warmprompt: "溫馨提示：請填寫正確的錢包地址，否則無法取款，取款錢包地址一經填寫綁定無法修改，如需修改請聯系客服",
		tips: "請至少綁定一個錢包地址，忘記密碼時無法找回",
		TRC20: "為避免輸入錯誤，請複製後長按此處粘貼（TRC20）",
		toBind: "立即綁定",
		noBind: "暫不綁定",
	},
	luckyhash: { //幸运哈希
		walletName: '連結錢包',
		exchange: "兌換",
		reward: "獎勵",
		Customerservice: "客服",
		instructions: "說明",
		luckyhash: "區塊鏈遊戲",
		entertainment: "娛樂城",
		Doublesided: "雙面",
		odds: "賠率",
		immediately: "立即投注",
		combination: "組合",
		LongHuge: "龍虎合",
		baccarat: "百家樂",
		gallbladder: "獨膽",
		Hashracingcar: "雜湊賽車",
		Hashspeedboat: "雜湊快艇",
		Hashracing: "哈希賽馬",
		bothsides: "兩面",
		problem: "常見問題",
		all: "查看更多",
		friend: "合作夥伴"
	},
	history: {
		block: "區塊",
		type: "類型",
		big: "大",
		highly: "區塊高度",
		results_of: "結果"
	},
	entertainment: {
		lastBlock: "上期區塊",
		resultValue: "開獎結果",
		currentblock: "當前區塊",
		nextBlock: "本次開獎區塊",
		toLotteryRecord: "開獎記錄",
		block: "區塊",
		money1: "金額",
		type: "類型",
		all: "查看更多",
		both_sides: "兩面",
		big: "大",
		small: "小",
		single: "單",
		double: "雙",
		champion: "冠軍",
		yajun: '亞軍',
		he: "和",
		champion_one_size: "冠軍單碼",
		crown: "冠亞和",
		andbig: "和大",
		andsmall: "和小",
		andsingle: "和單",
		anddouble: "和雙",
		championtwo: "冠軍兩面",
		combination: "組合",
		forlarge: "大單",
		smallsingle: "小單",
		large_double: "大雙",
		small_double: "小雙",
		Long_Huge: "龍虎合",
		dragon: "龍",
		tiger: "虎",
		us: "合",
		baccarat: "百家樂",
		zhuang: "莊",
		idle: "閑",
		gallbladder: "獨膽",
		Atotalof: "共",
		note: "注",
		Check_the_details: "查看詳情",
		money: "錢包餘額",
		pause: "機選",
		reset: "重置",
		inputmoney: "請輸入金額",
		submit: "提交",
		password: "輸入交易密碼",
		betting: "投注",
		determine: "確定",
	},
	details: {
		block: "區塊",
		money: "金額",
		type: "類型",
		resultValue: "開獎結果",
		all: "查看更多",
		address: "投注地址",
		toLotteryRecord: "開獎記錄",
		money: "錢包投注",
		copy: "複製投注地址",
		ts: "請勿使用交易所地址，否則無法收到返獎",
		USDT: "請轉帳波場USDT/TRX（Trc20）",
		Betting_amount: "投注金額",
		inputmoney: "請輸入投注金額",
		confirm: "確認",
		cancel: "取消",
	},
	data: {
		noData: '暫無數據',
		deleteSuc: '删除成功',
		iscon: '確認投注？',
		fenpan: '封盤中，期間不可進行下注',
		erweima: '保存二維碼'
	},
	phone: {
		title: '綁定手機號',
		phone: '手機號',
		input: '請輸入綁定的手機號',
		code: '驗證碼',
		inputcode: "請輸入驗證碼",
		getCode: '獲取驗證碼',
		details: '請先填寫區號、手機號',
		success: '驗證碼發送成功',
		bsuccess: '綁定成功',
		jiaoyi: '請先設定交易密碼',
		caozuo: "操作成功",
		touxiang: "請選擇一個頭像",
		buzu: '餘額不足',
		tuiguan: '推廣中心',
		qubie: '點擊查看區塊鏈錢包區別',
		yhm: '請輸入您的用戶名',
		mm: '請輸入您的密碼',
		xqgg: '先去逛逛',
		llwm: '聯繫我們',
		lj: '請先連接錢包',
		dk: '請在錢包APP中打開',
		qd: '期待您的加入',
		yjmx: '傭金明細'
	},
	vip: {
		jl: "獎勵",
		xrjl: '新人獎勵',
		ckgz: '查看規則',
		zcsj: '注册送金',
		qbsj: '綁定手機跟錢包地址',
		dlq: '待領取',
		qwc: '去完成',
		ylq: '已領取',
		tgrw: '推廣任務',
		rwjl: '任務獎勵',
		yq: '邀請',
		ghy: '個優質好友',
		lqcg: '領取成功',
		bz: "请输入充值币种",
		je: '请输入充值金额',
		xyb: '下一步',
		czpz: '请上传充值凭证',
		zzhx: '请输入转账哈希',
		ljtj: '立即提交'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Traditional.js